import { StyledButton } from 'src/app/components/Pages/GetStarted/styles';
import type { EscriptProps, OptimisticPendingTransfer } from 'src/app/types';

import { Divider, List, ListItem, Number, SectionTitle } from '../../styles';
import { StyledMedicationList } from '../StyledMedicationList';

interface DefaultRxProcessingProps {
  escriptCounts: EscriptProps[];
  medications: OptimisticPendingTransfer[];
  onContinue: () => void;
}

const DefaultRxProcessing = ({ escriptCounts, medications, onContinue }: DefaultRxProcessingProps) => {
  return (
    <>
      <Divider />
      <SectionTitle>What's Next</SectionTitle>
      <List>
        <ListItem hasMarginBottom={true}>
          <Number>1.</Number>
          <>We are processing your prescriptions. We'll text you within one hour to schedule free delivery</>
        </ListItem>
        <ListItem hasMarginBottom={true}>
          <Number>2.</Number>Pay your usual insurance copay
        </ListItem>
        <ListItem>
          <Number>3.</Number>Schedule your free, same-day delivery
        </ListItem>
      </List>
      <Divider />
      {escriptCounts?.length ? (
        <>
          <SectionTitle>Doctor</SectionTitle>
          <StyledMedicationList medications={medications} escriptCounts={escriptCounts} hideMedicationHeader />
          <Divider />
        </>
      ) : null}
      <StyledButton onClick={onContinue} type="submit" size="medium" style={'capsuleBlue50'}>
        Continue
      </StyledButton>
    </>
  );
};

interface RxProcessingProps {
  escriptCounts: EscriptProps[];
  medications: OptimisticPendingTransfer[];
  onContinue: () => void;
}

export const RxProcessing = ({ escriptCounts, medications, onContinue }: RxProcessingProps) => {
  return <DefaultRxProcessing escriptCounts={escriptCounts} medications={medications} onContinue={onContinue} />;
};
